@layer reset, default;

@layer reset {
  :host {
    display: block;
  }
}

@layer default {
  :host .gcds-stepper .gcds-stepper__steps {
    font: var(--gcds-stepper-font-desktop);
    display: block;
    margin: var(--gcds-stepper-margin-desktop);

    @media only screen and (width < 48em) {
      font: var(--gcds-stepper-font-mobile);
      margin: var(--gcds-stepper-margin-mobile);
    }
  }
}
